// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useEffect, useMemo, useState} from 'react';
import {useHistory} from 'react-router';
import etask from 'zetask';
import hola_opt from 'hola_opt';
// @ts-ignore
import '../../../../../hola/pub/css/join_n.less';
import {use_qs_with_set} from '../../../../../hola/pub/lib/use_qs';
import {Data_context} from '../../../../../hola/pub/data_ctx';
import {get_list_of_products} from '../../../../../hola/pub/ui/pro/products';
import {Checkout_layout}
    from '../../../ui/checkout/checkout_layout/checkout_layout';
import {use_data_provider}
    from '../../../../../hola/pub/lib/use_data_provider';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {Payment_form} from '../../../ui/checkout/payment_form/payment_form';
import {get_payment_method} from '../../../ui/checkout/payment_form/api_utils';
// @ts-ignore
import {set} from '/util/storage.js';
// @ts-ignore
import cookie from 'cookie';
import {App_context} from 'hola_app_context';
import {perr_www_visit} from 'hola_pub_util';
import Icon_arrow_right from '../../../../../hola/pub/img/hola2023/icons/24/arrow_right.svg';
import {Button} from '../../../../../hola/pub/lib/button';

const get_data_id = ()=>'purchase_eligibility';

export const Root = ()=>{
    const [submitting, set_submitting] = useState(false);
    const {qs, set_qs} = use_qs_with_set();
    const {plan_id = 'toolip_shared_dc_xs_short', method_id = 'cc',
        zone_id, group_id, renew_payment, migrate_product_id} = qs;
    const is_renew_payment = !!renew_payment;
    const {user} = useContext(App_context);
    const history = useHistory();
    const data_context = useContext(Data_context);
    const list_of_products = useMemo(()=>get_list_of_products('toolip'), []);
    const plan = hola_opt.all_plans.find(p=>p.id==plan_id);
    const plan_config = hola_opt.plans_config[plan_id];
    const product = list_of_products.find(item=>item.value==plan.type);
    const [usage_charges, set_usage_charges] = useState(false);
    useEffect(()=>{
        perr_www_visit({id: 'toolip_checkout_visit'});
    }, []);
    const [cc_method, set_cc_method] =
      useState(()=>get_payment_method(plan_id).provider);
    const {data} = use_data_provider(get_data_id);
    const {purchase_disabled, need_kyc} = data?.result || {};
    const on_payment_done = (_res, email)=>{
        const signup_token = _res && _res.signup_token ||
            cookie.get('signup_token');
        const password = _res && _res.password || cookie.get('temp_pass');
        set('thank_you_zone_type', plan_config?.type);
        if (signup_token && password)
        {
            set('temp_pass', password);
            cookie.remove('temp_pass');
            set('thank_you_dashboard', 1);
            location.href = '/dashboard/page/plans?thank_you=1'
                +`&email=${encodeURIComponent(email)}&signup_success=1`;
            return;
        }
        if (!user)
        {
            history.push('/dashboard/page/plans?thank_you=1'
                +`&email=${encodeURIComponent(email)}&signup_failed=1`);
            return;
        }
        history.push('/dashboard/page/plans?thank_you=1'
            +`&email=${encodeURIComponent(email)}&user_exists=1`);
    };
    const refresh_after_cc_payment_success = ()=>{
        data_context?.clear_cache();
        data_context?.reset();
    };
    const show_usage_charges = false; // xxx maksimd: disabled
        //  method_id == 'cc' && cc_method == 'stripe' &&
        // (plan.type == 'smart_resi' || plan.type == 'events_resi_tickets');
    return <Checkout_layout
      total={plan.price}
      plan={plan}
      plan_config={plan_config}
      period={plan_config.period}
      is_isp={['isp', 'isp_plus'].includes(product.value)}
      is_isp_plus={['isp_plus'].includes(product.value)}
      package_gb={plan_config.limit}
      ips_amount={plan_config?.ips_amount}
      product_type={product.title}
      title={is_renew_payment ? 'Update payment method': 'Checkout'}
      submitting={submitting}
      features={product.five_pluses}
      usage_charges={usage_charges}
      show_usage_charges={show_usage_charges}
      on_change_usage_charges={set_usage_charges}
      purchase_disabled={purchase_disabled}
      need_kyc={need_kyc}
      form={<Payment_form
        plan_id={plan_id}
        method_id={method_id}
        zone_id={zone_id}
        group_id={group_id}
        is_renew_payment={is_renew_payment}
        migrate_product_id={migrate_product_id}
        methods_allowed={renew_payment ? ['cc'] : undefined}
        usage_charges={usage_charges}
        on_change_usage_charges={set_usage_charges}
        cc_method={cc_method}
        show_usage_charges={show_usage_charges}
        set_cc_method={set_cc_method}
        purchase_disabled={purchase_disabled}
        set_payment_method={m=>set_qs({method_id: m})}
        submitting={submitting}
        set_submitting={set_submitting}
        on_payment_done={on_payment_done}
        refresh_after_cc_payment_success={refresh_after_cc_payment_success}
        need_kyc={need_kyc}
        Button_cmp={({on_click, tab_index})=><Button
          round={false}
          size='lg'
          caption={<>{is_renew_payment ? 'Update payment method' : 'Buy now'}
            <Icon_arrow_right/></>}
          on_click={on_click}
          tab_index={tab_index}
          disabled={submitting}
        />}
      />}
    />;
};

Root.meta = {
    headless: true,
    meta: ({translate})=>{
        translate = translate ? translate : t=>t;
        return {
            title: translate('Complete Your Purchase'),
            description: translate('Learn about complete your purchase and '
                +'how it can help you.'),
            canonical_url: 'https://toolip.io/pricing',
            robots: 'noindex',
        };
    },
    ssr_force: false,
    no_ssr: true,
    footless: true,
    headlogo: true,
    nav_opt: {transparent: 1},
    set_data_cache: (data_cache, _, data)=>{
        data_cache[get_data_id()] = data;
    },
    get_data_id,
    data_provider: data_cache=>etask(function*(){
        const cache_key = `purchase_eligibility_${hola_opt.user_ip}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        const url = 'https://toolip.io/api/check_purchase_eligibility' +
          `?ip=${hola_opt.user_ip}`;
        const data = yield fetch(url);
        const result = {
          purchase_disabled: !(data.res?.eligible ?? true),
          need_kyc: data.res?.need_kyc || false,
        };
        data_cache[cache_key] = result;
        return result;
    })
};
